import { ENUM_HOME_LAYOUT } from './../../core/Utils/global';
import { ParametersService } from './../../core/services/parameters.service';
import { ParameterModel } from './../../core/interfaces/parameter.model';
import { Component, HostListener, OnInit } from '@angular/core';
import { CategoryModel, CategoryMoviesModel } from 'src/app/core/interfaces/category.model';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/core/auth/auth.service';
import { MovieCategoryModel } from '../../core/interfaces/category.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public movies: MovieModel[] = [];

  public moviesSlideshow: MovieModel[] = [];
  public moviesEnSalas: MovieModel[] = [];
  public moviesPerCategories: CategoryMoviesModel[] = [];
  public moviesPremieres: CategoryMoviesModel; // Estrenos

  _ENUM_HOME_LAYOUT = ENUM_HOME_LAYOUT;
  PARAMS: ParameterModel;

  loading = false;
  scrollLoading = false;
  allLoaded = false;

  catMoviesList: CategoryMoviesModel[] = [];
  gridMoviesList: MovieModel[];
  categoryList: CategoryModel[];
  category: CategoryModel;
  filmicFile: MovieModel;

  nextLoadingIndex: number = 0;//Este es el Index de la categoria que se va a cargar.
  firstLoadingIndex: number = 0;//Primer Index en cargar.
  defaultLoadingAmount: number = 3;//Esta es la cantidad de categorias que se cargan si o si al principio.
  scrollLoadingAmount: number = 3;//Esta es la cantidad de categorias que se cargan con cada scroll nuevo.

  constructor(
    private moviesService: MoviesService,
    private categoriesService: CategoriesService,
    private parametersService: ParametersService,
    private auth: AuthService,
  ) { }

  async ngOnInit() {
    // this.cargarDatos();
    this.newCargarDatos();
  }

  ngOnDestroy(): void {
    // this.peliculasService.resetCarteleraPage();
  }

  async newCargarDatos() {
    this.loading = true;
    this.PARAMS = await this.parametersService.getAllParameters();

    if (this.PARAMS) {

      this.categoriesService.getAllCategoriesForHome().subscribe(async (res) => {
        this.categoryList = res;

        this.checkStoredContent();//Chequea el storage y si hay algo lo carga antes de hacer calls a api.

        // Peliculas en el slideshow
        if (this.moviesSlideshow.length == 0) {
          let slides: MovieModel[] = await this.moviesService.GetFeaturedMoviesFromCategory().toPromise();
          if (slides) this.moviesSlideshow = slides;
          this.moviesService.store_HomeMoviesSlideshow(slides);//Store para la primera ves que se carga. Deberia ser una ves sola.
        }

        //Peliculas por rango de categoria
        if (this.moviesPerCategories.length == 0) {

          let catsMovies = await this.categoriesService.GetWithMoviesInRangeHome(this.firstLoadingIndex, this.defaultLoadingAmount).toPromise();
          if (catsMovies) this.moviesPerCategories = catsMovies;
          this.updateNextLoadingIndex(catsMovies);
          this.moviesService.store_HomeMoviesPerCategories(catsMovies);
        }

        this.loading = false;
      },
        (error) => {
          Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
        }
      )
    }

    this.moviesService.getFilmArchiveMovie().subscribe((movie) => {
      this.filmicFile = movie;
    });
  }

  updateNextLoadingIndex(lastLoad: CategoryMoviesModel[]) { //Funcion para asegurarse que si la api se saltea una categoria, el front se mantenga en orden.
    let lastCatTempId = lastLoad[lastLoad.length - 1].category.id;
    let catTemp = this.categoryList.find(c => c.id == lastCatTempId);
    this.nextLoadingIndex = this.categoryList.indexOf(catTemp) + 1;
  }

  checkStoredContent() {
    //Slides.
    let storedSlides = this.moviesService.get_HomeMoviesSlideshow();
    if (storedSlides.length != 0) {
      this.moviesSlideshow = storedSlides;//Si hay contenido storeado se carga.

    }

    //Categories.
    let catsMovies = this.moviesService.get_HomeMoviesPerCategories();
    if (catsMovies.length != 0) {
      this.moviesPerCategories = catsMovies;//Si hay contenido storeado se carga.
      this.updateNextLoadingIndex(catsMovies); //Importante, aca se indica cual va a ser lo proximo a cargar para el sistema de scroll.

      //Chequea si llego al final para no cargar scrolls de mas.
      this.compareCategoriesForEnding(catsMovies);
    }

  }

  async loadNextScroll() {
    let catsMovies = await this.categoriesService.GetWithMoviesInRangeHome(this.nextLoadingIndex, this.scrollLoadingAmount).toPromise();
    if (catsMovies) {
      catsMovies.forEach(c => {
        if (!this.moviesPerCategories.includes(c)) {
          this.moviesPerCategories.push(c);
        }
      });
    }

    this.moviesService.store_HomeMoviesPerCategories(this.moviesPerCategories);

    this.updateNextLoadingIndex(catsMovies);

    this.scrollLoading = false;

    //Chequea si llego al final para no cargar scrolls de mas.
    this.compareCategoriesForEnding(catsMovies);
  }

  compareCategoriesForEnding(toCompare: CategoryMoviesModel[]) {
    let lastCategoryId = this.categoryList[this.categoryList.length - 1].id;
    let lastRequestedId = toCompare[toCompare.length - 1].category.id;
    if (lastCategoryId == lastRequestedId) {
      this.allLoaded = true;//Importante, esto hace que deje de cargar enteramente.
    }
  }

  @HostListener("window:scroll", ["$event"])
  onScroll(event) {

    if (event.target.scrollingElement.scrollHeight - event.target.scrollingElement.scrollTop < environment.home_scroll_offset) {
      if (!this.scrollLoading && !this.allLoaded && !this.loading) {
        this.scrollLoading = true;
        this.loadNextScroll();
      }
    }
  }

}
